import withStyles from "@mui/styles/withStyles";
import Switch from "@mui/material/Switch";

const YellowSwitch = withStyles({
  switchBase: {
    color: "#DDD",
    "&$checked": {
      color: "#F1C12C"
    },
    "& + &track": {
      backgroundColor: "#F1C12C"
    },
    "&$checked + $track": {
      backgroundColor: "#F1C12C"
    }
  },
  checked: {},
  track: {}
})(Switch);

export default YellowSwitch;
